module.exports = __webpack_public_path__ + "static/media/cm2.7ba0ee61.png";